import {FC, ReactNode, RefObject} from 'react';
import clsx from 'clsx';
import TooltipWrapper from 'components/Tooltip';
import {useTooltip} from 'components/Tooltip/hook';
import {TruncateOnSize} from '../types';

type TooltipBoxProps = {
    children: ReactNode;
    className: string;
};

const TooltipBox: FC<TooltipBoxProps> = ({children, className}) => {
    const {setTooltipRef} = useTooltip();

    return (
        <div ref={(ref) => setTooltipRef(ref)} className={className}>
            {children}
        </div>
    );
};

const WhitespaceNowrap: Record<TruncateOnSize, string> = {
    default: 'whitespace-nowrap',
    lg: 'lg:whitespace-nowrap',
    md: 'md:whitespace-nowrap',
    sm: 'sm:whitespace-nowrap',
};

type TruncatorWrapperProps = {
    children: ReactNode;
    className?: string;
    contentRef?: RefObject<HTMLDivElement>;
    message?: string;
    truncateOnSize?: TruncateOnSize;
};

const TruncatorWrapper: FC<TruncatorWrapperProps> = ({
    children,
    className,
    contentRef,
    message = '',
    truncateOnSize = 'default',
}) => (
    <TooltipWrapper message={message}>
        <TooltipBox className={clsx(className)}>
            <div
                ref={contentRef}
                className={clsx(WhitespaceNowrap[truncateOnSize])}
            >
                <div className="flex flex-row flex-nowrap">{children}</div>
            </div>
        </TooltipBox>
    </TooltipWrapper>
);

export default TruncatorWrapper;
